/**
 * Defines different dimension names that provide context to different metrics.
 */
export enum MetricDimensionNames {
  PROGRAM_DIMENSION = 'program',
}

/**
 * MetricType supported by Katal
 */
export enum MetricType {
  String,
  Counter,
  Timer,
}

export const METRIC_NAME_MAX_CHAR_LENGTH = 127;

// Method Names
export const METHOD_NAME_MY_ASSORTMENT = 'MyAssortment';
export const METHOD_NAME_PAGE_VIEW = 'PageView';
export const METHOD_NAME_SUPER_CAT = 'SuperCat';
export const METHOD_NAME_BULK_UPLOAD = 'BulkUpload';

// Metric Names
export const METRIC_NAME_CREATE_ASSORTMENT = 'CreateAssortment';
export const METRIC_NAME_TOOL_OPENED = 'ToolOpened';
export const METRIC_NAME_GO_TO_ASSORTMENT = 'GoToAssortment';
export const METRIC_NAME_BULK_EDIT = 'BulkEdit';
export const METRIC_NAME_ADD_ITEM = 'AddNewItems';
export const METRIC_NAME_SAVE = 'Save';
export const METRIC_NAME_FILTERS_TAPPED = 'FiltersTapped';
export const METRIC_NAME_COLUMN_FILTERING = 'ColumnFilters';
export const METRIC_NAME_COLUMN_SORT = 'ColumnSort';

export const METRIC_NAME_GO_TO_BULK_UPLOAD = 'GoToBulkUpload';
export const METRIC_NAME_GENERATE_DIFF = 'ClickGenerateDiff';
export const METRIC_NAME_BATCH_SWAP_ASSORTMENT = 'ConfirmBatchSwapAssortment';
export const METRIC_NAME_PUBLISH_DRAFT_ZONE_MAP = 'ConfirmPublishDraftZone';

export default MetricDimensionNames;
